import React, { useContext, useEffect, useState } from "react";
import apiClient from "../../ApiEndpoint/apiClient";
import { List, Typography, Space, Empty, Button } from 'antd';
import { Tabs } from "antd";
import { Select } from "antd";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import Spinner from "../Spinner/spinner.js";
import apiUrl from "../../ApiEndpoint/config";
import "./companydetails.css"
import { from, of } from "rxjs";
import {
  debounceTime,
  switchMap,
  catchError,
  filter,
} from "rxjs/operators";
const { Option } = Select;
const { TabPane } = Tabs;

const CompanyTabs = () => {
  const { groupName, groupInfo } = useContext(RegisterIdContext);
  const [companyData, setCompanyData] = useState(null);
  const [groupSuatainability, setGroupSuatainability] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [newsloading, setNewsLoading] = useState(true);
  const [projectDetail, setProjectDetail] = useState({});
  const [projectDetailLoading, setProjectDetailLoading] = useState(false);
  const { projectId } = useContext(RegisterIdContext);
  const [activeTabKey, setActiveTabKey] = useState("1");


  useEffect(() => {
    const fetchCompanyData = async () => {
      setCompanyData(null); // Reset company data before fetching
      if (groupInfo) {
        try {
          const response = await apiClient.get(`${apiUrl}/sec_info`, {
            params: { cik: groupInfo.CIK, group: groupName },
          });
          if (response.data) {
            if (Array.isArray(response.data) && response.data.length > 0) {
              setCompanyData(response.data[0]);
            } else if (
              typeof response.data === "object" &&
              Object.keys(response.data).length > 0
            ) {
              setCompanyData(response.data);
            } else {
              setCompanyData(groupInfo);
            }
          }
        } catch (error) {
          console.error("Error fetching company data:", error);
          // Fallback to groupInfo in case of API error
          setCompanyData(groupInfo);
        }
      } else {
        setCompanyData(groupInfo);
      }
    };

    fetchCompanyData();
  }, [groupInfo]);



  useEffect(() => {
    const fetchGroupData = async () => {
      if (groupName) {
        try {
          const response2 = await apiClient.get(`${apiUrl}/facility_sustainability`, {
            params: { group: groupName },
          });
          setGroupSuatainability(response2.data);
        } catch (error) {
          //console.error("Error fetching company data:", error);
          setGroupSuatainability({ Message: "An error occurred. Please contact the Administrator." });
        }
      } else {
      }
    };

    fetchGroupData();
  }, [groupName]);

  //contact api integration
  useEffect(() => {
    const fetchContacts = async () => {
      setLoading(true);
      if (groupName) {
        try {
          const response = await apiClient.get(`${apiUrl}/get_contacts`, {
            params: { group_name: groupName },
          });
          setContacts(response.data.contacts || []);
        } catch (error) {
          //console.error("Error fetching contacts:", error);
          setContacts([]);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchContacts();
  }, [groupName]);


  //news api integration
  useEffect(() => {
    if (!groupName) return;

    const controller = new AbortController();
    const signal = controller.signal;

    const groupName$ = of(groupName).pipe(
      debounceTime(1000),
      filter((name) => !!name), // guard against empty
      switchMap((name) =>
        from(
          apiClient.get(`${apiUrl}/parent_comp_news`, {
            params: { parent_company_name: name },
            signal,
          })
        ).pipe(
          catchError((error) => {
            console.error("Error fetching news:", error);
            setNewsData([]);
            return of(null);
          })
        )
      )
    );

    setNewsLoading(true);
    const subscription = groupName$.subscribe((response) => {
      if (response?.data) {
        setNewsData(response.data);
      }
      setNewsLoading(false);
    });

    return () => {
      controller.abort();
      subscription.unsubscribe();
    };
  }, [groupName]);

  //Project Detail api integration
  useEffect(() => {
    if (!projectId) {
      setProjectDetail([]); // clear previous details
      return;
    }
    setActiveTabKey("3");
    const controller = new AbortController();
    const signal = controller.signal;

    const projectId$ = of(projectId).pipe(
      debounceTime(1000),
      filter((id) => !!id), // Guard against falsy IDs
      switchMap((id) =>
        from(
          apiClient.get(`${apiUrl}/projects-detail`, {
            params: { projectId: id },
            signal,
          })
        ).pipe(
          catchError((error) => {
            console.error("Error fetching project detail:", error);
            setProjectDetail([]);
            return of(null);
          })
        )
      )
    );

    setProjectDetailLoading(true);

    const subscription = projectId$.subscribe((response) => {
      if (response?.data) {
        setProjectDetail(response.data);
      }
      setProjectDetailLoading(false);
    });

    return () => {
      subscription.unsubscribe();
      controller.abort();
    };
  }, [projectId]);






  return (
    <div className="card" style={{ padding: '10px' }}>
      <Tabs defaultActiveKey="1" activeKey={activeTabKey} onChange={(key) => setActiveTabKey(key)}>
        <TabPane tab="Company Details" key="1">
          <Tabs defaultActiveKey="1">
            <TabPane tab="Overview" key="1">
              <Overview data={companyData} groupName={groupName} />
            </TabPane>
            <TabPane tab="Financial Reports" key="2">
              <FinancialReports data={companyData} groupName={groupName} />
            </TabPane>

          </Tabs>
        </TabPane>
        <TabPane tab="Sustainability Goals" key="2">
          <SustainabilityGoals
            groupSuatainability={groupSuatainability}
          />
        </TabPane>
        <TabPane tab="Project Details" key="3">
          <ProjectDetailsTab projectDetail={projectDetail} projectDetailLoading={projectDetailLoading} groupName={groupName} />
        </TabPane>
        <TabPane tab="Contacts" key="4">
          <Contacts
            contacts={contacts} loading={loading} />
        </TabPane>

        <TabPane tab="News" key="5">
          <News newsData={newsData} newsloading={newsloading} />


        </TabPane>
      </Tabs>
    </div>
  );
};

const Overview = ({ data, groupName }) => {
  return (
    <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
      {/* Always show group name */}
      <h5 style={{ color: '#098192', paddingTop: '10px', paddingBottom: '10px', fontWeight: '800' }}>
        {groupName}
      </h5>

      {/* Show loader if data is not yet loaded */}
      {!data ? (
        <Spinner />
      ) : (
        <>
          <h6 style={{ fontWeight: '800' }}>Company Background</h6>
          <p>{data?.Company_Background || "Data Not available"}</p>

          <h6 style={{ fontWeight: '800' }}>Business Sectors & Industries</h6>
          <p>{data?.["Business_Sectors_&_Industries"] || "Data Not available"}</p>

          <h6 style={{ fontWeight: '800' }}>Global Expansion & Trade Partners</h6>
          <p>{data?.["Global_Expansion_&_Trade_Partners"] || "Data Not available"}</p>
        </>
      )}
    </div>
  );
};


const FinancialReports = ({ data, groupName }) => {

  const financialData = data;

  if (!financialData) {
    return <Spinner />;
  }

  const revenue = financialData?.Revenue_and_Profitability?.Revenue;
  const profitability = financialData?.Revenue_and_Profitability?.Profitability;
  // const netIncome = financialData?.Revenue_and_Profitability?.Profitability?.Net_Income;
  // const operatingIncome = financialData?.Revenue_and_Profitability?.Profitability?.Operating_Income;



  const operatingExpenses = financialData?.Operating_Expenses;
  const capitalExpenditures = financialData?.["Capital_Expenditures_(CapEx)"];
  const sustainabilityInvestments = financialData?.Sustainability_Investments;

  const operatingCashFlow = financialData?.Cash_Flow?.Operating_Cash_Flow;
  const freeCashFlow = financialData?.Cash_Flow?.Free_Cash_Flow;
  const cashOnHand = financialData?.Cash_Flow?.Cash_on_Hand;

  const totalDebt = financialData?.Debt_and_Liabilities?.Total_Debt;
  const interestExpense = financialData?.Debt_and_Liabilities?.Interest_Expense;

  const roe = financialData?.Key_Performance_Metrics?.["Return_on_Equity_(ROE)"];
  const currentRatio = financialData?.Key_Performance_Metrics?.Current_Ratio;
  const inventoryTurnover = financialData?.Key_Performance_Metrics?.Inventory_Turnover_Ratio;

  const expansionPlans = financialData?.Strategic_Initiatives_for_the_Current_Financial_Year?.Expansion_Plans;
  const sustainabilityGoals = financialData?.Strategic_Initiatives_for_the_Current_Financial_Year?.Sustainability_Goals;
  const digitalTransformation = financialData?.Strategic_Initiatives_for_the_Current_Financial_Year?.Digital_Transformation;


  return (
    <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
      <h6 style={{ color: '#098192', paddingTop: '10px', paddingBottom: '10px', fontWeight: '800' }}>
        Key Financial Highlights - {groupName}
      </h6>

      <h6 style={{ fontWeight: '800' }}>Revenue and Profitability</h6>
      <ul>
        {revenue && (
          <>

            <li>Revenue: {revenue ?? 'Data not available'}</li>
          </>
        )}

        {profitability && (
          <>

            <li>Profitability: {profitability ?? 'Data not available'}</li>
          </>
        )}
        {/* <li>Net Income: {netIncome ?? 'Data not available'}</li>
        <li>Operating Income: {operatingIncome ?? 'Data not available'}</li> */}
      </ul>

      <h6 style={{ fontWeight: '800' }}>Operating Expenses</h6>
      <p>{operatingExpenses ?? 'Data not available'}</p>

      <h6 style={{ fontWeight: '800' }}>Capital Expenditures (CapEx)</h6>
      <p>{capitalExpenditures ?? 'Data not available'}</p>

      <h6 style={{ fontWeight: '800' }}>Sustainability Investments</h6>
      <p>{sustainabilityInvestments ?? 'Data not available'}</p>

      <h6 style={{ fontWeight: '800' }}>Cash Flow</h6>
      <ul>
        <li>Operating Cash Flow: {operatingCashFlow ?? 'Data not available'}</li>
        <li>Free Cash Flow: {freeCashFlow ?? 'Data not available'}</li>
        <li>Cash on Hand: {cashOnHand ?? 'Data not available'}</li>
      </ul>

      <h6 style={{ fontWeight: '800' }}>Debt and Liabilities</h6>
      <ul>
        <li>Total Debt: {totalDebt ?? 'Data not available'}</li>
        <li>Interest Expense: {interestExpense ?? 'Data not available'}</li>
      </ul>

      <h6 style={{ fontWeight: '800' }}>Key Performance Metrics</h6>
      <ul>
        <li>Return on Equity (ROE): {roe ?? 'Not available'}</li>
        <li>Current Ratio: {currentRatio ?? 'Not available'}</li>
        <li>Inventory Turnover Ratio: {inventoryTurnover ?? 'Not available'}</li>
      </ul>

      <h6 style={{ fontWeight: '800' }}>Strategic Initiatives for the Current Financial Year</h6>
      <ul>
        <li><strong>Expansion Plans:</strong> {expansionPlans ?? 'Not available'}</li>
        <li><strong>Sustainability Goals:</strong> {sustainabilityGoals ?? 'Not available'}</li>
        <li><strong>Digital Transformation:</strong> {digitalTransformation ?? 'Not available'}</li>
      </ul>


    </div>
  );
};


const SustainabilityGoals = ({ groupSuatainability }) => {
  if (!groupSuatainability) {
    return <Spinner />;
  }
  const { Message, Citations } = groupSuatainability;
  return (
    <div>
      <h5
        style={{
          color: "#098192",
          paddingTop: "10px",
          paddingBottom: "10px",
          fontWeight: "800",
        }}
      >
        Sustainability Goals
      </h5>
      <p>{Message}</p>
      {Citations && Citations.length > 0 && (
        <ul>
          {Citations.map((citation, index) => {
            // Match Markdown-style [label](url)
            const match = citation.match(/\[([^\]]+)\]\(([^)]+)\)/);
            if (!match) return null;

            const label = match[1];
            const url = match[2];

            return (
              <li key={index}>
                <span>{label}:</span>{" "}
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};



const Contacts = ({ contacts, loading }) => {

  return (

    <div style={{ maxHeight: "70vh", overflowY: "scroll" }} >
      {loading ? (
        <Spinner />
      ) : contacts.length > 0 ? (
        contacts.map((contact, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              marginBottom: "8px",
              padding: "10px"
            }}
          >
            <h5 style={{ color: "#098192", fontWeight: '800', marginBottom: "5px", fontSize: '16px' }}>
              {contact.CONTACT_NAME || "Contact"}
              <span style={{ color: "#FFAC00", marginLeft: '3rem', fontWeight: 500, fontSize: '16px' }}>
                ({contact.EMPLOYEE_STATUS__C || "Status Unknown"})
              </span>
            </h5>
            <p className="mb-1 company-text"><strong>Name:</strong> {contact.ACCOUNT_NAME || "N/A"}</p>
            <p className="mb-1 company-text"><strong>Job Description:</strong> {contact.JOBCODEDESCRIPTION__C || contact.TITLE || "N/A"}</p>
            <p className="mb-1 company-text"><strong>Phone:</strong> {contact.MOBILE_PHONE || "N/A"} {contact.ASSISTANT_PHONE ? `| Assistant: ${contact.ASSISTANT_PHONE}` : ""}</p>
            <p className="mb-1 company-text"><strong>Do Not Call:</strong> {contact.DO_NOT_CALL ? "Yes" : "No"}</p>
            <p className="mb-1 company-text"><strong>Email:</strong><span className="text-primary">  {contact.EMAIL}</span>({contact.EMAIL_VERIFICATION_STAUTS__C || "Unknown"})</p>
            <p className="mb-1 company-text"><strong>Opted Out of Email:</strong> {contact.HAS_OPTED_OUT_OF_EMAIL ? "Yes" : "No"}</p>
            <p className="mb-1 company-text"><strong>HubSpot Score:</strong> {contact.HS_HUBSPOT_SCORE__C || "N/A"}</p>
            <p className="mb-1 company-text"><strong>Engagement:</strong> {contact.HS_TEMPERATURE__C || "N/A"}</p>
            <p className="mb-1 company-text"><strong>Related Facility:</strong> {contact.PLANT_NAME__C || "N/A"}</p>
            <p className="mb-1 company-text"><strong>Influence:</strong> {contact.POSITION_OF_INFLUENCE__C || "Unknown"}</p>
            <p className="mb-1 company-text">
              <strong>LinkedIn Search Link:</strong>{" "}
              <a href={contact.LINKEDIN_SEARCH__C} target="_blank" rel="noopener noreferrer">
                {contact.LINKEDIN_SEARCH__C}
              </a>
            </p>
            <p className="mb-1" style={{ textAlign: 'right' }}><strong>Last Modified:</strong> {new Date(contact.LAST_MODIFIED_DATE).toLocaleDateString()}</p>

          </div>
        ))
      ) : (
        <p>No contact information found.</p>
      )}
    </div >
  );
};

const News = ({ newsloading, newsData }) => {

  return (
    <div style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16 }}>
      <Typography.Title
        level={5}
        style={{ borderBottom: "2px solid #52c41a", paddingBottom: 8 }}
      >
        Relevant News
      </Typography.Title>

      <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {newsloading ? (
          <Spinner />
        ) : newsData.length > 0 ? (
          <List
            dataSource={newsData}
            renderItem={(item, index) => (
              <List.Item
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "12px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <Typography.Text strong style={{ fontSize: 16 }}>
                  {item.Title}
                </Typography.Text>
                <Typography.Text type="secondary" style={{ marginBottom: 8 }}>
                  {new Date(item.date).toLocaleDateString()}
                </Typography.Text>
                <Button
                  type="primary"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                >
                  Read More
                </Button>
              </List.Item>
            )}
          />
        ) : (
          <Empty description="No news found" />
        )}
      </div>
    </div>
  )
}

const ProjectDetailsTab = ({ projectDetail, projectDetailLoading, groupName }) => {
  const { setProjectId, projectId } = useContext(RegisterIdContext);
  const { projectList } = useContext(RegisterIdContext);
  const [selectedProjectId, setSelectedProjectId] = useState(null);


  const projectInfo = projectDetail?.projects?.[0];
  //const projectContact = projectInfo?.projectCompaniesSummary[0]
  useEffect(() => {
    if (projectInfo) {
    }
  }, [projectInfo]);

  useEffect(() => {
    setSelectedProjectId(null);
  }, [groupName]);

  useEffect(() => {
    if (projectId) {
      setSelectedProjectId(projectId);
    }
  }, [projectId]);


  const getKeysWithValueOne = (obj) => {
    if (!obj || typeof obj !== 'object') return 'N/A';

    const keys = Object.keys(obj).filter((key) => obj[key] === 1);
    return keys.length > 0 ? keys.join(',') : 'N/A';
  };


  const handleProjectChange = (value) => {
    setSelectedProjectId(value);
    setProjectId(value);
  };

  return (
    <>
      <div style={{ maxHeight: "70vh", overflowY: "scroll" }}>

        <div>
          <Select
            showSearch
            allowClear
            style={{ width: 560 }}
            placeholder="Select a project"
            optionFilterProp="children"
            value={selectedProjectId}
            onChange={handleProjectChange}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {projectList.map((project) => (
              <Option
                key={project.projectId}
                value={project.projectId}
                label={`${project.projectName} (${project.projectStatus})`}
              >
                {project.projectName} ({project.projectStatus})
              </Option>
            ))}
          </Select>
        </div>
        <div>
          {projectDetailLoading ? (
            <Spinner />
          ) : projectInfo && Object.keys(projectInfo).length > 0 ? (
            <>
              <h6 className="mt-3">Project Scope</h6>
              <p>{projectInfo?.scope}</p>

              <div className="detection-item">
                <h6 className="details-title mt-3">Project Details</h6>


                <p>
                  <span className="left col-4">Project Name:</span>
                  <span className="right col-8">{projectInfo?.projectName ?? "N/A"}</span>
                </p>


                <p>
                  <span className="left col-4">TIV:</span>
                  <span className="right col-8">
                    {projectInfo?.localTiv != null
                      ? new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(projectInfo.localTiv)
                      : "N/A"}
                  </span>

                </p>

                <p>
                  <span className="left col-4">Project Status:</span>
                  <span className="right col-8">{projectInfo?.projectStatusDesc ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Project SIC:</span>
                  <span className="right col-8">{projectInfo?.projectSicDesc ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Schedule:</span>
                  <span className="right col-8">{projectInfo?.schedule ?? "N/A"}</span>
                </p>


              </div>


              <div className="detection-item">
                <h6 className="details-title mt-3">Project Owner Details</h6>
                <p>
                  <span className="left col-4">Project Owner Name:</span>
                  <span className="right col-8">{projectInfo?.projectOwnerName ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Plant Name:</span>
                  <span className="right col-8">{projectInfo?.plantName ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Plant SIC</span>
                  <span className="right col-8">{projectInfo?.plantSicDesc ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Plant Owner Name</span>
                  <span className="right col-8">{projectInfo?.plantOwnerName ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Plant Parent Name</span>
                  <span className="right col-8">{projectInfo?.plantParentName ?? "N/A"}</span>
                </p>

              </div>


              <div className="detection-item">
                <h6 className="details-title mt-3">Plant Physical Address</h6>
                <p>
                  <span className="left col-4">Address Line 1:</span>
                  <span className="right col-8">{projectInfo?.plantPhysicalAddress?.addressLine1 ?? "N/A"}</span>
                </p>

                <p>
                  <span className="left col-4">City:</span>
                  <span className="right col-8">{projectInfo?.plantPhysicalAddress?.city ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">County:</span>
                  <span className="right col-8">{projectInfo?.plantPhysicalAddress?.countyName ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">State:</span>
                  <span className="right col-8">{projectInfo?.plantPhysicalAddress?.stateName ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Country:</span>
                  <span className="right col-8">{projectInfo?.plantPhysicalAddress?.countryName ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Postal Code:</span>
                  <span className="right col-8">{projectInfo?.plantPhysicalAddress?.postalCode ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-4">Plant Phone:</span>
                  <span className="right col-8">{projectInfo?.plantPhone ?? "N/A"}</span>
                </p>

                <p>
                  <span className="left col-10 mt-2">Project Evaluation Cycle timing:</span>
                  <span className="right col-2">{projectInfo?.pecTiming ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-10">Project Evaluation Activity:</span>
                  <span className="right col-2">{projectInfo?.pecActivityDesc ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-10">Construction Labor Preference:</span>
                  <span className="right col-2">
                    {projectInfo?.constructionLaborPreference === 1
                      ? "Yes"
                      : projectInfo?.constructionLaborPreference === 0
                        ? "No"
                        : "N/A"}
                  </span>
                </p>
                <p>
                  <span className="left col-10">Operations Labor Preference:</span>
                  <span className="right col-2">
                    {projectInfo?.operationsLaborPreference === 1
                      ? "Yes"
                      : projectInfo?.operationsLaborPreference === 0
                        ? "No"
                        : "N/A"}
                  </span>
                </p>
                <p>
                  <span className="left col-10">RFQ Date:</span>
                  <span className="right col-2">
                    {projectInfo?.rfqYearMonth
                      ? `${String(projectInfo.rfqYearMonth).slice(0, 4)}/${String(projectInfo.rfqYearMonth).slice(4).padStart(2, '0')}`
                      : "N/A"}
                  </span>
                </p>
                <p>
                  <span className="left col-10">Kick Off Date:</span>
                  <span className="right col-2">
                    {projectInfo?.kickoffYearMonth
                      ? `${String(projectInfo.kickoffYearMonth).slice(0, 4)}/${String(projectInfo.kickoffYearMonth).slice(4).padStart(2, '0')}`
                      : "N/A"}
                  </span>
                </p>
                <p>
                  <span className="left col-5">Project Sector:</span>
                  <span className="right col-7">{projectInfo?.projectSectorDesc ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-5">Project Key Assets:</span>
                  <span className="right col-7" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.6' }}> {getKeysWithValueOne(projectInfo?.energyProcessKeyNeeds ?? "N/A")}</span>
                </p>
                <p>
                  <span className="left col-5">Project Key Engineering needs:</span>
                  <span className="right col-7" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.6' }}> {getKeysWithValueOne(projectInfo?.engineeringKeyNeeds ?? "N/A")}</span>
                </p>
                <p>
                  <span className="left col-5">Project Key needs:</span>
                  <span className="right col-7" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.6' }}> {getKeysWithValueOne(projectInfo?.projectKeyNeeds ?? "N/A")}</span>
                </p>
                <p>
                  <span className="left col-5">Environmental Requirements</span>
                  <span className="right col-7" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.6' }}> {getKeysWithValueOne(projectInfo?.environmental ?? "N/A")}</span>
                </p>
                <p>
                  <span className="left col-5">Energy Process Key Needs</span>
                  <span className="right col-7" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.6' }}> {getKeysWithValueOne(projectInfo?.energyProcessKeyNeeds ?? "N/A")}</span>
                </p>

                <p>
                  <span className="left col-5">Energy Procurements Needed</span>
                  <span className="right col-7" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.6' }}> {getKeysWithValueOne(projectInfo?.buy ?? "N/A")}</span>
                </p>
                <p>
                  <span className="left col-5">Existing Capacity:</span>
                  <span className="right col-7">{projectInfo?.installedCapacity ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-5">New Planned Capacity:</span>
                  <span className="right col-7">{projectInfo?.plannedCapacity ?? "N/A"}</span>
                </p>
                <p>
                  <span className="left col-5">Capacity UOM</span>
                  <span className="right col-7">{projectInfo?.uom ?? "N/A"}</span>
                </p>

              </div>



              {projectInfo?.projectCompaniesSummary?.map((company, index) => {
                const contacts = company.internalContacts || [];

                if (contacts.length === 0) return null;

                return (
                  <React.Fragment key={`internal-${index}`}>
                    <h2 className="opp-main-heading">{projectInfo?.projectCompaniesSummary[0].companyInfo?.companyName} - Contact List</h2>
                    <div key={index} className="opportunity-container">
                      {contacts.map((contact) => (
                        <div key={contact.contactId} className="opportunity">
                          <div className="opportunity-name">
                            {contact.firstName} {contact.lastName}
                          </div>
                          <ul className="opportunity-details">
                            <li>
                              <strong>Company:</strong>{" "}
                              {company?.companyInfo?.companyName ?? "N/A"}
                            </li>
                            <li>
                              <strong>Firm Type:</strong> {contact?.firmTypeDesc ?? "N/A"}
                            </li>
                            <li>
                              <strong>Title:</strong> {contact?.titleDesc ?? "N/A"}
                            </li>
                            <li>
                              <strong>Contact ID:</strong> {contact?.contactId ?? "N/A"}
                            </li>
                            <li>
                              <strong>Email:</strong> {contact?.emailAddress ?? "N/A"}
                            </li>
                            <li>
                              <strong>LinkedIn:</strong>{" "}
                              {contact?.linkedInId ? (
                                <a
                                  href={`https://www.linkedin.com/in/${contact.linkedInId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {contact.linkedInId}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </li>
                            <li>
                              <strong>Phone:</strong> +{contact.phone?.cc ?? ""}{" "}
                              {contact.phone?.number ?? ""}
                            </li>
                            {contact.phone?.ext && (
                              <li>
                                <strong>Ext:</strong> {contact.phone.ext}
                              </li>
                            )}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                );

              })}

              {projectInfo?.projectCompaniesSummary?.map((company, index) => {
                const contacts = company.externalContacts || [];

                if (contacts.length === 0) return null;

                return (
                  <React.Fragment key={`internal-${index}`}>
                    <h2 className="opp-main-heading">External Vendor {projectInfo?.projectCompaniesSummary[0].companyInfo?.companyName} - Contact List</h2>
                    <div key={index} className="opportunity-container">
                      {contacts.map((contact) => (
                        <div key={contact.contactId} className="opportunity">
                          <div className="opportunity-name">
                            {contact.firstName} {contact.lastName}
                          </div>
                          <ul className="opportunity-details">
                            <li>
                              <strong>Company:</strong>{" "}
                              {company?.companyInfo?.companyName ?? "N/A"}
                            </li>
                            <li>
                              <strong>Firm Type:</strong> {contact?.firmTypeDesc ?? "N/A"}
                            </li>
                            <li>
                              <strong>Title:</strong> {contact?.titleDesc ?? "N/A"}
                            </li>
                            <li>
                              <strong>Contact ID:</strong> {contact?.contactId ?? "N/A"}
                            </li>
                            <li>
                              <strong>Email:</strong> {contact?.emailAddress ?? "N/A"}
                            </li>
                            <li>
                              <strong>LinkedIn:</strong>{" "}
                              {contact?.linkedInId ? (
                                <a
                                  href={`https://www.linkedin.com/in/${contact.linkedInId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {contact.linkedInId}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </li>
                            <li>
                              <strong>Phone:</strong> +{contact.phone?.cc ?? ""}{" "}
                              {contact.phone?.number ?? ""}
                            </li>
                            {contact.phone?.ext && (
                              <li>
                                <strong>Ext:</strong> {contact.phone.ext}
                              </li>
                            )}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                );
              })}
            </>
          ) : (
            <div style={{ marginTop: "20px" }}>
              <h6>No project selected or project details not available.</h6>
            </div>
          )}
        </div>
      </div>
    </>
  );
};



export default CompanyTabs;
